export const campaigns = {
  1: 2091125,

  2: 2091126,

  3: 2091127,

  4: 2091128,
};

export const urlCode = {
  rma: 1093542,
  iscp: 1843334,
  era: 1582572,
};
